import * as Yup from 'yup';

const LoginValidator = Yup.object().shape({
    email: Yup.string()
    .email('Email Invalido')
    .required('El email es requerido'),
    password: Yup.string()
    .required('Ingrese una contraseña'), 
});

export default LoginValidator;